/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MeusDadosAliases {
  CARD_0 = 'card-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_0 = 'fetch-0',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FORM_0 = 'form-0',
  LAYOUT_0 = 'layout-0',
  LINK_ALTERAR_SENHA = 'link-alterar-senha',
  LINK_PRIVACIDADE = 'link-privacidade',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_MEUS_DADOS = 'panel-meus-dados',
  PANEL_ULTIMO_ACESSO = 'panel-ultimo-acesso',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_ULTIMO_ACESSO = 'text-ultimo-acesso',
}
export { MeusDadosAliases };
